import './RankingCard.css';
import React from 'react';

import { RankingPropsTypes } from '@models/Ranking';
import { RightOutlined } from '@ant-design/icons';
import Link from 'redux-first-router-link';
import config from '@config';

const { maxParticipantsPerGroup } = config;

export const RankingCard = ({ _id, name, owner, isOwner, participants }) => (
  <Link to={`/rankings/${_id}`} className="ranking-card-link">
    <div className="ranking-card">
      <div className="name">{name}</div>
      <div className="participants">
        {participants.length} / {maxParticipantsPerGroup}
      </div>
      <div className="role">{isOwner ? 'Admin' : 'Invitado'}</div>
      <RightOutlined />
    </div>
  </Link>
);

RankingCard.displayName = 'RankingCard';
RankingCard.propTypes = RankingPropsTypes;
RankingCard.defaultProps = {
  participants: [],
  isOwner: false,
};

RankingCard.Header = () => (
  <div className="ranking-card ranking-card-header">
    <div className="name">Torneo</div>
    <div className="participants">Participantes</div>
    <div className="role">Rol</div>
  </div>
);
RankingCard.Header.displayName = 'RankingCardHeader';

export default RankingCard;
